import EventBus from "../../events/EventBus";
import { addGlobalLiveEventListener } from "../../utils";
import { useSetsApi } from "../user_sets/api";
export function initConstructorCards() {
    addGlobalLiveEventListener('click', '.js-add-to-set', async (event) => {
        const button = event.target;
        const offerId = parseInt(button.getAttribute('data-offer-id'));
        handleAddToSetButtonClick(offerId, button, button.dataset.name || '');
    });
}
export async function handleAddToSetButtonClick(offerId, button, name) {
    if (!button || button.disabled) {
        return;
    }
    if (!offerId) {
        return;
    }
    const labelSpan = button.querySelector('.btn__label');
    const originalText = labelSpan ? labelSpan.textContent : 'В сет';
    try {
        button.disabled = true;
        const response = await useSetsApi().addItem(offerId);
        if (response.ok) {
            if (labelSpan) {
                labelSpan.textContent = 'Добавлено';
            }
            EventBus.emit('set:update', response.data);
            setTimeout(() => {
                if (labelSpan && labelSpan.textContent === 'Добавлено') {
                    labelSpan.textContent = originalText;
                    button.disabled = false;
                }
            }, 1000);
        }
        else {
            if (response.error.limit) {
                EventBus.emit('set:replacement-requested', {
                    id: offerId,
                    name: name,
                });
            }
            else {
                console.warn(Object.values(response.error)[0] ?? 'Ошибка добавления');
                // TODO (toast): Показать ошибку добавления в сет (errorMessage)
            }
            button.disabled = false;
        }
    }
    catch (e) {
        console.error(e);
        // TODO (toast): Показать системную ошибку/сетевой сбой ('Произошла системная ошибка при добавлении в сет')
        button.disabled = false;
    }
}
